/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonthlyAllocationSummaryDtoFromJSON, MonthlyAllocationSummaryDtoToJSON, } from './MonthlyAllocationSummaryDto';
/**
 * Check if a given object implements the UserAllocationsResponseDto interface.
 */
export function instanceOfUserAllocationsResponseDto(value) {
    return true;
}
export function UserAllocationsResponseDtoFromJSON(json) {
    return UserAllocationsResponseDtoFromJSONTyped(json, false);
}
export function UserAllocationsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'startMonth': json['startMonth'] == null ? undefined : json['startMonth'],
        'startYear': json['startYear'] == null ? undefined : json['startYear'],
        'endMonth': json['endMonth'] == null ? undefined : json['endMonth'],
        'endYear': json['endYear'] == null ? undefined : json['endYear'],
        'monthlyAllocations': json['monthlyAllocations'] == null ? undefined : (json['monthlyAllocations'].map(MonthlyAllocationSummaryDtoFromJSON)),
        'grandTotalAllocationDays': json['grandTotalAllocationDays'] == null ? undefined : json['grandTotalAllocationDays'],
        'totalProjectsCount': json['totalProjectsCount'] == null ? undefined : json['totalProjectsCount'],
    };
}
export function UserAllocationsResponseDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'userId': value['userId'],
        'userName': value['userName'],
        'startMonth': value['startMonth'],
        'startYear': value['startYear'],
        'endMonth': value['endMonth'],
        'endYear': value['endYear'],
        'monthlyAllocations': value['monthlyAllocations'] == null ? undefined : (value['monthlyAllocations'].map(MonthlyAllocationSummaryDtoToJSON)),
        'grandTotalAllocationDays': value['grandTotalAllocationDays'],
        'totalProjectsCount': value['totalProjectsCount'],
    };
}
